import { render, staticRenderFns } from "./PcRadio.vue?vue&type=template&id=0eb30ab9&scoped=true"
import script from "./PcRadio.vue?vue&type=script&lang=js"
export * from "./PcRadio.vue?vue&type=script&lang=js"
import style0 from "./PcRadio.vue?vue&type=style&index=0&id=0eb30ab9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb30ab9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio})
